<template>
  <div>
    <main class="aboutus">
      <main-header negative fixed />
      <sui-loader v-show="fetching" class="general-loader" size="large" active centered inline />
      <section
        v-show="!fetching"
        class="aboutus__introduction aboutus__container"
        v-html="phrase"
      ></section>

      <sui-grid
        :columns="numberColumns"
        v-show="!fetching"
        class="aboutus__offices aboutus__container"
        centered
      >
        <sui-grid-row class="alignedstyle">
          <sui-loader v-show="fetching" active centered inline />
          <sui-grid-column v-show="!fetching" v-for="(office, index) in offices" :key="index">
            <office-presentation
              :city="office.city"
              :telphone="office.telphone"
              :address="office.address"
              :country="office.country"
              :socials="office.socials"
              :image="office.image"
            />
          </sui-grid-column>
        </sui-grid-row>
      </sui-grid>

      <filter-country
        v-show="!fetching"
        negative
        class="aboutus__filter"
        @onSelectFilter="filterEmployers($event)"
      />

      <employers
        :employers="filteredEmployees"
        :columns="numberColumns"
        class="aboutus__container"
        :visible="visible"
        v-show="!fetching"
        :fetching="fetching"
        :filtering="filtering"
      />

      <filter-country
        v-show="!fetching"
        negative
        class="aboutus__filter"
        :text="$t('generals.ourclients')"
        @onSelectFilter="filterLogos($event)"
      />
      <clients
        :columns="numberColumns"
        v-show="!fetching"
        class="aboutus__container"
        :visible="logosVisible"
        :clients="filteredClients"
      />
      <scroll-to />
    </main>

    <main-footer ref="footer" negative />
  </div>
</template>

<script>
import OfficePresentation from "../components/office-presentation";
import Employers from "../components/employers";
import Clients from "../components/clients";

export default {
  name: "aboutus",
  components: {
    OfficePresentation,
    Employers,
    Clients,
  },
  data() {
    return {
      visible: true,
      logosVisible: true,
      numberColumns: 4,
      fetching: true,
      filtering: false,
      offices: [],
      employees: [],
      clients: [],
      phrase: null,
      filteredEmployees: [],
      filteredClients: [],
    };
  },

  beforeCreate() {
    $("body, html, #app").css("background", "black");
  },

  mounted() {
    $("body, html, #app").css("background", "black");
    this.getData(this.$store.state.ui.language);
    this.setColumns();

    $(window).on("resize", () => {
      this.setColumns();
    });

    this.$store.dispatch("setNegativeLayout", true);
    this.$hub.$on("repeatRequests", (language) => {
      this.getData(language);
    });
  },

  destroyed() {
    this.$store.dispatch("setNegativeLayout", false);
    $("body, html, #app").removeAttr("style");
    this.$hub.$off("repeatRequests");
  },

  methods: {
    getData(language) {
      this.fetching = true;

      this.$about
        .getData(language)
        .then((resolve) => {
          const { employees, offices, clients, phrase } = resolve.data;

          this.offices = offices;
          this.employees = employees;
          this.filteredEmployees = this.filterRepeated(employees);
          this.clients = clients;
          this.filteredClients = clients;
          this.phrase = phrase;

          this.toggleItems("visible");
          this.toggleItems("logosVisible");
          document.dispatchEvent(new Event("prerender-ready"));
        })
        .catch(() => {
          document.dispatchEvent(new Event("prerender-ready"));
        })
        .finally(() => {
          this.fetching = false;
        });
    },

    setColumns() {
      const width = $(window).width();

      if (width < 1000) {
        this.numberColumns = 2;
        return;
      }

      this.numberColumns = 4;
    },

    filterEmployers(obj) {
      this.filtering = true;
      this.filteredEmployees = [];

      setTimeout(() => {
        const filteredList = this.employees.filter((employer) => {
          const parse = {
            "Buenos Aires": "buenosaires",
            "São Paulo": "saopaulo",
            Miami: "miami",
            Madrid: "madrid",
            Bogota: "bogota",
            "New York": "new-york",
          };

          return employer.regional_slug === parse[obj.value];
        });

        this.filteredEmployees =
          obj.value !== "all" ? filteredList : this.filterRepeated(this.employees);

        this.toggleItems("visible");
        this.filtering = false;
      }, 200);
    },

    filterRepeated(arr) {
      return arr.filter(
        (tag, index, array) => array.findIndex((t) => t.name === tag.name) === index
      );
    },

    filterRepeatedByCountry(arr) {
      return arr.filter(
        (tag, index, array) =>
          array.findIndex((t) => t.name === tag.name && t.regional_slug === tag.regional_slug) ===
          index
      );
    },

    filterLogos(obj) {
      const filteredList = this.clients.filter((client) => {
        const parse = {
          "Buenos Aires": "buenosaires",
          "São Paulo": "saopaulo",
          Miami: "miami",
          Madrid: "madrid",
          Bogota: "bogota",
          "New York": "new-york",
        };

        return client.regional_slug.includes(parse[obj.value.trim()]);
      });

      this.filteredClients = obj.value !== "all" ? filteredList : this.clients;
      this.toggleItems("logosVisible");
    },

    toggleItems(key) {
      this[key] = false;

      setTimeout(() => {
        this[key] = true;
      }, 50);
    },
  },
};
</script>

<style lang="scss">
.alignedstyle {
  justify-content: left !important;
}
.aboutus {
  background: black;
  height: 100%;
  padding-top: 60px;
  min-height: 100vh;
  margin-bottom: 300px;
  overflow: hidden;
  position: relative;
  z-index: 2;

  &__container {
    max-width: 1900px;
    margin: 0 auto !important;
    padding: 0 30px !important;
  }

  &__introduction {
    color: white;
    font-size: 48px;
    font-weight: 300;
    line-height: 1.3em;
    margin: 70px auto !important;

    span {
      font-family: $david !important;
    }
  }

  &__offices {
    margin: 100px auto !important;

    &.aboutus__container {
      padding: 0 10px !important;
    }
  }

  &__filter {
    margin: 120px 0;
  }
}

@media (max-width: 1900px) {
  .aboutus {
    &__introduction {
      font-size: 48px;
    }

    &__filter {
      margin: 6vw 0;
    }
  }
}

@media (max-width: 1000px) {
  .aboutus {
    &__filter {
      margin: 20px 0 40px;
    }

    &__container {
      padding: 0 20px !important;
    }

    &__introduction {
      font-size: 23px;
      margin: 40px 0 10px !important;
    }

    &__offices {
      margin: 60px auto 10px !important;

      .row {
        .column {
          padding: 0 5px 0 !important;
        }
      }
    }
  }
}
</style>
